import React from 'react';
import { Form, DatePicker } from 'antd';

import { Logo } from '../../sharedComponents/';
import { Header, Content, ContentFooter, Footer } from '../../LayoutComponents/';

export default function Step04({ goToNextStep }) {
  const Titles = () => <h1 className="text-4xl text-center text-white">What is your date of birth?</h1>;

  const [form] = Form.useForm();

  const handleSubmit = async () => {
    const values = await form.validateFields();
    console.log({ values });
    goToNextStep();
  };

  return (
    <>
      <Header>
        <div className="bg-black bg-opacity-60 p-5 mb-5">
          <div className="text-center my-5" style={{ fontSize: 30, textAlign: 'center', whiteSpace: 'nowrap' }}>
            <Logo />
          </div>

          <Titles />
        </div>
      </Header>

      <Content>
        <div className="flex p-5" style={{ justifyContent: 'center' }}>
          <div className="p-4 bg-black bg-opacity-60 rounded-xl" style={{ width: '100%', maxWidth: '460px' }}>
            <Form form={form} layout="vertical" className="w-full">
              {/*
              <label className="block text-white" htmlFor="name">
                What is your date of birth?
              </label>
              */}
              <Form.Item name="birthday" rules={[{ required: true, message: 'Please enter your birthday' }]}>
                {/* https://ant.design/components/date-picker */}
                <DatePicker
                  className="rounded-xl"
                  size="large"
                  onChange={() => console.log('test')}
                  style={{ width: '100%' }}
                />
              </Form.Item>

              <div className="flex items-baseline justify-between">
                <button
                  onClick={handleSubmit}
                  className="w-full px-12 py-4 mt-4 text-white text-lg rounded-lg bg-blue-700 disabled:bg-blue-400 hover:bg-blue-800"
                >
                  Next
                </button>
              </div>
            </Form>
          </div>
        </div>
      </Content>

      <Footer className="flex" style={{ justifyContent: 'center' }}>
        <div className="flex" style={{ maxWidth: '1050px', justifyContent: 'center' }}></div>
      </Footer>
    </>
  );
}
